import type { Contrato, ContratoDoPlano } from "@/api/contrato";
import type { Matiz } from "@/componentes/PilulaDeSituacao";

/*
 * A situação do contrato na paleta de estados: o vigente no verde de "tudo
 * certo", o futuro no âmbar de "ainda não valendo", o encerrado no cinza sem
 * drama. A situação vem DERIVADA do servidor — a tela não recalcula vigência
 * pelo relógio do navegador.
 */
export const MATIZ_DA_SITUACAO: Record<Contrato["situacao"], Matiz> = {
  vigente: "pago",
  futuro: "transito",
  encerrado: "encerrado",
};

/**
 * Quem tem o contrato: a aplicação, ou a clínica dentro dela (contrato de par,
 * change `add-cobranca-por-cedente`). As duas aparecem na lista do plano, e a
 * confirmação comercial precisa distinguir "o Agenda Maker" de "a Clínica X no
 * Agenda Maker" — são faturas diferentes.
 */
export function nomeDoContratante(contrato: ContratoDoPlano): string {
  return contrato.pessoa_nome === null
    ? contrato.sistema_nome
    : `${contrato.pessoa_nome} · ${contrato.sistema_nome}`;
}
